/**
 * Utility helpers — general-purpose functions used across the app.
 * Phase 2+ will add auth helpers, date formatters, etc.
 */

/**
 * Formats a JS Date to a human-readable Indian locale string.
 * @example formatDate(new Date()) // "24 Apr 2026"
 */
export function formatDate(date: Date): string {
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Capitalises the first letter of every word in a string.
 */
export function titleCase(str: string): string {
  return str
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
